import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
    <p><strong>Description</strong></p>
    <p>This Alerts triggers every 2 hours whenever a station has 35+ Inducted Not Containerized Packages that have been
      dwelling for 180+ Mins.&nbsp;</p>
    <p><strong>Impact</strong></p>
    <p>
      There are 13.5M defects estimated this year for items that go through induct but never receive another scan
      afterwards, specifically a stow scan into a container. These ‘inducted not containerized’ packages break happy path
      and contribute
      5.5bps to DEA lost, $12.8M to DEA impact cost, and $4.1M in rework labor cost.&nbsp;
    </p>
    <p><strong>Resolution Steps</strong></p>
    <p>
      1.Check Re-work Carts - Reinduct any re-work carts from the end of sort clusters and/or IB areas. Follow the steps
      outline in START's
      <span className="wikiinternallink">
        <a
          href="https://start.wwops.amazon.dev/boards/browse?boardId=IjEyMDI3Ig%3D%3D&amp;businessUnitId=IjMi&amp;cardId=IjIzNjA1NiI%3D&amp;selectedTagValueIds=WyIzMDQiLCIzMTUiLCIzNzkiXQ%3D%3D&amp;topLevelFilters=eyI0IjoiNDEiLCI2IjoiNTgifQ%3D%3D#h1-236056-1"
        >
          Pick to buffer &amp; Stow (NA) SOP - Rework
        </a>
      </span>
      .
    </p>
    <p>
      2.Check Problem Solve - Follow START's
      <span className="wikiinternallink">
        <a
          href="https://start.wwops.amazon.dev/boards/browse?boardId=IjEyMTgwIg%3D%3D&amp;businessUnitId=IjMi&amp;cardId=IjIzNjkyNyI%3D&amp;selectedTagValueIds=WyIzMDQiLCIzMzA3IiwiMzY3Il0%3D&amp;topLevelFilters=eyI0IjoiNDIiLCI2IjoiNTQifQ%3D%3D#h1-236927-1"
        >
          Problem Solve Staffing SOP
        </a>
      </span>
      to ensure problem solve is staffed correctly and Problem Solve Packages are resolved throughout the sort Shift to
      ensure there is not a Backlog (BL) at the end of sortation. &nbsp;Follow START's
      <span className="wikiinternallink">
        <a
          href="https://start.wwops.amazon.dev/boards/browse?boardId=IjE4NTI3Ig%3D%3D&amp;businessUnitId=IjMi&amp;cardId=IjI2MzI2OSI%3D&amp;selectedTagValueIds=WyIzMDQiLCIzMzA3IiwiMzY3Il0%3D&amp;topLevelFilters=eyI0IjoiNDIiLCI2IjoiNTQifQ%3D%3D#h1-263269-1"
        >
          Problem Solve - Sortation
        </a>
      </span>
      for additional details.&nbsp;
    </p>
    <p>3.Check the MHE - look around the conveyor(s) in case packages have fallen off the MHE (Material Handling Equipment).
      Gather and re-process when safe, work with RME and local ACES on continuous design issues.&nbsp;</p>
    <p>
      4.Check buffer rack conditions - if a sort aisle’s buffer rack is extremely full it is likely that these packages have
      been dwelling for an extended period of time. Review dwelling heat map hourly and move headcount to help stow down
      full
      racks.
    </p>
    <p>
      5.High dwelling but empty buffer rack - if a sort aisle’s buffer rack is empty but virtually shows high counts of
      dwelling, Check for totes of jiffys nearby and under the conveyor belt. Double check OV items are virtually stowed
      correctly. Follow up with learning for associate retraining if necessary.&nbsp;
    </p>
    <p>
      6.For more resolution steps please see
      <span className="wikiinternallink">
        <a
          href="https://start.wwops.amazon.dev/boards/browse?boardId=IjE4NTI3Ig%3D%3D&amp;businessUnitId=IjMi&amp;selectedTagValueIds=WyIzMDQiLCIzMzA3IiwiMzY3Il0%3D&amp;topLevelFilters=eyI0IjoiNDIiLCI2IjoiNTQifQ%3D%3D#18527">
          Sortation Problem Solve SOP
        </a>
      </span>
      .
    </p>
    <p><strong>Supplemental Links</strong></p>
    <p>
      1.
      <span className="wikiinternallink">
        <a
          href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/5571ef06-acb5-4bae-a3ed-5d19a4859a62/sheets/5571ef06-acb5-4bae-a3ed-5d19a4859a62_2275a8a3-aa88-429c-91ea-77b6a5aedb77?directory_alias=amzlbiaquicksight&amp;qs-signin-user-auth=false"
        >
          FPY Dashboard
        </a>
      </span>
      <br/>
      2.
      <span className="wikiinternallink">
        <a
          href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/e5996fbe-2141-490a-adad-d5e8819be562/sheets/e5996fbe-2141-490a-adad-d5e8819be562_012c3736-bc21-428a-a187-996fe2ea26c2">
          NA AMZL Manager (SCC &amp; GCA) Alert Qicksight Dashboard
        </a>
      </span>
      <br/>
      3.
      <span className="wikiinternallink">
        <a
          href="https://start.wwops.amazon.dev/boards/browse?boardId=IjEyMzE5Ig%3D%3D&amp;businessUnitId=IjMi&amp;cardId=IjIzNzcyMyI%3D&amp;selectedTagValueIds=WyIzMDQiLCIzMTUiLCIzNzkiXQ%3D%3D&amp;topLevelFilters=eyI0IjoiNDEiLCI2IjoiNDkifQ%3D%3D#h1-237723-1"
        >
          START Tetris
        </a>
      </span>
      <br/>
      4.
      <span className="wikiinternallink">
        <a
          href="https://start.wwops.amazon.dev/boards/browse?boardId=IjE4NTI3Ig%3D%3D&amp;businessUnitId=IjMi&amp;selectedTagValueIds=WyIzMDQiLCIzMzA3IiwiMzY3Il0%3D&amp;topLevelFilters=eyI0IjoiNDEiLCI2IjoiNTgifQ%3D%3D#18527">
          START Problem Solve Sortation
        </a>
      </span>
    </p>
  </div>`
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Inducted_Not_Containerized.jsx